export function getGtmUserData(name?: string | null) {
  const fullName = name?.trim() ? name.trim() : "guest";
  const nameParts = fullName.split(/\s+/).filter(Boolean);
  const firstName = nameParts[0] || "guest";
  const lastNameParts = nameParts.slice(1);

  return {
    address: {
      first_name: firstName,
      last_name: lastNameParts.join(" "),
    },
  };
}
